module.exports = __webpack_public_path__ + "img/medications.a67fb78d.svg";